import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";

import { useAccount, useMsal } from "@azure/msal-react";
import { Role } from "../shared/enums/Role";

export default function CreateApplicationButtonsManager() {
  const navigate = useNavigate();
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const role = account !== undefined && account?.idTokenClaims !== undefined && account?.idTokenClaims["extension_Roles"];

  return (
    <div>
      {role == Role.manager ? (
        <div className="flex absolute create-application">
          <Button
            label="Create Legacy Application"
            onClick={() => navigate("/ApplicationBaseLegacy/createApplication")}
            autoFocus
            icon="pi pi-plus-circle text-2xl"
            className=" filled-round-button mr-2"
          />
          <Button
            label="Create Application"
            onClick={() => navigate("/kindergarten/screening")}
            autoFocus
            icon="pi pi-plus-circle text-2xl"
            className="filled-round-button"
          />
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
